import axios from "../axios";

const getTransactions = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('/bank-transaction/getTransactions',params, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getTransactions;
